import { render, staticRenderFns } from "./sales-vs-stock.vue?vue&type=template&id=68bea5a5&scoped=true"
import script from "./sales-vs-stock.vue?vue&type=script&lang=js"
export * from "./sales-vs-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bea5a5",
  null
  
)

export default component.exports